<template>
  <master-main
    :exportProperties="{
      pdf: {
        filename: 'metodos_de_poda.pdf',
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: 'metodos_de_poda.xlsx',
        route: `${getModuleRoute}/excel`,
      },
    }"
    :route="getModuleRoute"
    :showProperties="showProperties"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-create
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import EditCreate from './EditCreate';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';
import PruningTable from './pruning-method-table';

export default {
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '52%' },
    };
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinMain,
    MixinPermissions,
    MixinWithDialog,
  ],

  computed: {
    getModuleRoute() {
      return 'pruning/methods';
    },

    buildTableProperties() {
      return {
        effectTags: 'dark',
        tableColumns: [...PruningTable().tableColumns],
        defaultSort: { prop: 'code', order: 'ascending' },
      };
    },
  },
};
</script>
